<template>
  <Button ref="loadMoreButton" @click="load">
    <slot>Load more&hellip;</slot>
  </Button>
</template>

<script>
/* Renderless Inifinite Loader Component */
export default {
  props: {
    load: {
      required: true,
      type: Function,
    },
  },
  data() {
    return {
      observer: null,
    };
  },
  beforeDestroy() {
    this.destroyIntersectionObserver();
  },
  mounted() {
    this.setupIntersectionObserver();
  },
  methods: {
    destroyIntersectionObserver() {
      // Check for an observer and destroy it if it exists...
      this.observer && this.observer.disconnect();
      this.observer = null;
    },
    isIntersectionObserverNotSupported() {
      // Check for IntersectionObserver support
      // If it's not supported (IE🙄) then return false...
      return (
        !("IntersectionObserver" in window) ||
        !("IntersectionObserverEntry" in window) ||
        !("intersectionRatio" in window.IntersectionObserverEntry.prototype)
      );
    },
    setupIntersectionObserver() {
      if (this.isIntersectionObserverNotSupported()) return false;

      // If we already have an observer return false...
      if (this.observer) return false;

      // Wait for the DOM to update...
      this.$nextTick(() => {
        // Grab our button reference...
        const loadMoreButton = this.$get(
          this,
          "$refs.loadMoreButton.$el",
          null
        );

        // Setup our observer and grab the first item from the array...
        this.observer = new IntersectionObserver(([entry]) => {
          // If we have an entry and it is intersecting then load more elements...
          if (entry && entry.isIntersecting) {
            // If we've been passed a load prop then run it now...
            if (this.load && typeof this.load === "function") this.load();
          }
        });

        // Pass in our button reference to observe...
        if (loadMoreButton) this.observer.observe(loadMoreButton);
      });
    },
  },
};
</script>
